import React, { useEffect } from 'react';

const FileListeners = ({ eventEmitter, applyStoreAction }) => {
    const listen = () => {
        eventEmitter.on('file_processed', file => {
            applyStoreAction({
                type: 'FILE_ADD_SOCKET',
                payload: {
                    fileId: file.id,
                    file
                }
            });

            applyStoreAction({
                type: 'FILE_UPLOAD_COMPLETE',
                payload: {
                    fileId: file.id,
                    fileName: file.name
                }
            });
        });

        eventEmitter.on('file_upload', file => {
            applyStoreAction({
                type: 'FILE_UPLOAD_PROGRESS',
                payload: {
                    fileId: file.file_id,
                    fileName: file.name,
                    loaded: file.loaded
                }
            });
        });

        eventEmitter.on('file_removed', file => {
            applyStoreAction({
                type: 'FILE_REMOVE_SOCKET',
                payload: { fileId: file.file_id }
            });
        });
    }

    useEffect(listen, []);

    return null;
}

export default FileListeners;
